import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';

const StarSVG = ({ filled }) => (
  <svg 
    className="review-star-svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      className={filled ? 'filled' : ''}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3378 14.3165C10.134 14.1777 9.86601 14.1777 9.66222 14.3165L5.50414 17.1488C5.03892 17.4657 4.43275 17.0253 4.59036 16.4849L5.99912 11.6551C6.06816 11.4184 5.98535 11.1636 5.79036 11.0126L1.81177 7.93329C1.36664 7.58877 1.59818 6.87617 2.1608 6.85908L7.18954 6.7064C7.43601 6.69891 7.6528 6.5414 7.73608 6.30932L9.43526 1.57388C9.62536 1.04407 10.3746 1.04407 10.5647 1.57388L12.2639 6.30932C12.3472 6.5414 12.564 6.69891 12.8105 6.7064L17.8392 6.85908C18.4018 6.87617 18.6334 7.58877 18.1882 7.93329L14.2096 11.0126C14.0146 11.1636 13.9318 11.4184 14.0009 11.6551L15.4096 16.4849C15.5672 17.0253 14.9611 17.4657 14.4959 17.1488L10.3378 14.3165Z"
      fillOpacity="1"
    />
  </svg>
);

const ReviewsVerticalElement = ({ element }) => {
  const { replaceTemplates } = useOnboarding();
  const style = applyStyles(element);

  if (!element.reviews || !Array.isArray(element.reviews)) {
    return null;
  }

  return (
    <div className="element-reviews-vertical" style={style}>
      {element.reviews.map((review, index) => (
        <div key={index} className="review-vertical-card">
          {review.title && (
            <div className="review-vertical-title">
              {replaceTemplates(review.title)}
            </div>
          )}
          {review.starsCount !== undefined && (
            <div className="review-vertical-stars">
              {Array.from({ length: 5 }).map((_, i) => (
                <StarSVG key={i} filled={i < (parseInt(review.starsCount) || 5)} />
              ))}
            </div>
          )}
          {review.text && (
            <div className="review-vertical-text">
              {replaceTemplates(review.text)}
            </div>
          )}
          {(review.author || review.name) && (
            <div className="review-vertical-author">
              {replaceTemplates(review.author || review.name)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ReviewsVerticalElement;

